export default __webpack_public_path__ + "static/media/Rocket.ac739ee3.png";